/**
 * 홈 대시보드 중대재해처벌법 API 응답 → 레이더 차트 데이터
 * - 대분류는 API 건수만큼 동적으로 표시(8개 초과 가능)
 * - 「가점 사항」은 레이더 축에서 제외(총점 summary에는 API 값 사용)
 * @param {Array<{ codeNm?: string, value?: string|number, maxScore?: string|number, level?: string|number, evaDate?: string, categoryOrderNo?: number }>} seriousDisasterInfo
 * @param {{ obtainedScore?: string|number, totalScore?: string|number, evaDate?: string }} [summary]
 */
export function mapSeriousDisasterToRadar(seriousDisasterInfo, summary) {
  if (!seriousDisasterInfo?.length) {
    return { items: [], summary: null };
  }

  const isBonusCategory = (item) =>
    String(item.codeNm || '').trim() === '가점 사항';

  const sorted = [...seriousDisasterInfo]
    .filter((item) => !isBonusCategory(item))
    .sort(
      (a, b) =>
        (Number(a.categoryOrderNo) || 0) - (Number(b.categoryOrderNo) || 0)
    );

  const evaDate = summary?.evaDate ?? sorted.find((item) => item.evaDate)?.evaDate ?? null;

  const items = sorted.map((item) => {
    const label = String(item.codeNm || '').trim();
    const rawValue = Math.round(Number.parseFloat(item.value) || 0);
    const fullMark = Math.round(Number.parseFloat(item.maxScore) || 0) || 100;
    const normalized = fullMark > 0 ? (rawValue / fullMark) * 100 : 0;

    return {
      subject: `${label}(${rawValue})`,
      value: normalized,
      rawValue,
      fullMark,
      level: Number(item.level) || 0,
      evaDate,
    };
  });

  const obtainedScore =
    summary?.obtainedScore != null
      ? Math.round(Number.parseFloat(summary.obtainedScore) || 0)
      : items.reduce((sum, item) => sum + item.rawValue, 0);

  const totalScore =
    summary?.totalScore != null
      ? Math.round(Number.parseFloat(summary.totalScore) || 0)
      : items.reduce((sum, item) => sum + item.fullMark, 0);

  return {
    items,
    summary: {
      obtainedScore,
      totalScore,
      evaDate,
    },
  };
}
